import { Loader2 } from 'lucide-react';

import { Button } from '@/components/ui/button';

interface ListSelectionFooterProps {
  onSaveDraft: () => void;
  onCancel: () => void;
  onCarryOutCheck: () => void;
  isSaving?: boolean;
}

export function ListSelectionFooter({
  onSaveDraft,
  onCancel,
  onCarryOutCheck,
  isSaving = false,
}: ListSelectionFooterProps) {
  return (
    <footer className="fixed bottom-0 left-0 right-0 z-10 border-t border-[#D4DAE0] bg-white px-4 py-4 md:px-8">
      <div className="flex items-center justify-end">
        {/* Action buttons - stacked full-width on mobile, inline from sm */}
        <div className="flex w-full flex-col-reverse gap-3 sm:w-auto sm:flex-row sm:items-center sm:gap-4">
          <button
            type="button"
            onClick={onSaveDraft}
            disabled={isSaving}
            className="text-center text-[14px] text-[#051923] underline hover:no-underline disabled:opacity-50 sm:text-left"
          >
            Save Draft
          </button>
          <div className="flex gap-3 sm:gap-4">
            <Button
              type="button"
              variant="outline"
              onClick={onCancel}
              disabled={isSaving}
              className="h-[45px] flex-1 rounded-[5px] border-[#131313] px-6 text-[16px] font-medium text-[#131313] hover:bg-gray-50 sm:flex-none"
            >
              Cancel
            </Button>
            <Button
              type="button"
              onClick={onCarryOutCheck}
              disabled={isSaving}
              className="h-[45px] flex-1 rounded-[5px] bg-[#131313] px-6 text-[16px] font-medium text-white hover:bg-[#131313]/90 sm:flex-none"
            >
              {isSaving ? (
                <>
                  <Loader2 className="mr-2 h-4 w-4 animate-spin" />
                  Processing...
                </>
              ) : (
                'Carry Out Check'
              )}
            </Button>
          </div>
        </div>
      </div>
    </footer>
  );
}
